<template>
  <section id="home" class="hw-hero">
    <div class="hw-hero-grid"></div>
    <div class="hw-container hw-hero-inner">
      <div>
        <p class="hw-kicker">Software house em Portugal</p>
        <h1>
          Ligados pela <span class="hw-grad">inovação</span>.
          Conectados ao vosso <span class="hw-grad">sucesso</span>.
        </h1>
        <p class="hw-lead">
          A Hardwired concebe e desenvolve websites, aplicações móveis e plataformas digitais à medida.
          Engenharia sólida, comunicação clara e produtos que as vossas equipas realmente usam.
        </p>
        <div class="hw-hero-actions">
          <button class="hw-btn hw-btn-primary" @click="$vuetify.goTo('#contact', { offset: 12 })">
            Pedir proposta
          </button>
          <button class="hw-btn hw-btn-ghost" @click="$vuetify.goTo('#services', { offset: 12 })">
            Ver serviços
          </button>
        </div>
        <div class="hw-hero-meta">
          <div>
            <strong>2020</strong>
            <span>Primeiro produto</span>
          </div>
          <div>
            <strong>2024</strong>
            <span>Fundação da empresa</span>
          </div>
          <div>
            <strong>+40</strong>
            <span>Clientes no MKGest</span>
          </div>
        </div>
      </div>
      <div class="hw-stack">
        <article class="hw-float">
          <small>Plataformas</small>
          <strong>Sistemas à medida</strong>
          <p>Operações, clientes e dados no mesmo sítio, pensados para crescer convosco.</p>
        </article>
        <article class="hw-float">
          <small>Aplicações</small>
          <strong>Apps iOS e Android</strong>
          <p>Experiências nativas, com a vossa identidade até ao último toque.</p>
        </article>
        <article class="hw-float">
          <small>Websites</small>
          <strong>Websites que convertem</strong>
          <p>Presença digital rápida, clara e alinhada com o negócio.</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Home",
};
</script>
